module.exports = "/_next/static/images/a9b3cc41c2f0f39d976b18b07e0b15e0-heart-emoji.jpeg";